export const updateObject = (old, updated) => {
  return { ...old, ...updated };
};
